import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/sliders.vue
var s = {
	name: "DtIconSliders",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--sliders"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Sliders",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M2 1a.5.5 0 0 1 .5.5V5a.5.5 0 1 1-1 0V1.5A.5.5 0 0 1 2 1Zm.5 6.5H3a.5.5 0 1 0 0-1H1a.5.5 0 0 0 0 1h.5v3a.5.5 0 1 0 1 0v-3Zm4-1.5a.5.5 0 1 0-1 0v4.5a.5.5 0 1 0 1 0V6ZM6 1a.5.5 0 0 1 .5.5v2H7a.5.5 0 1 1 0 1H5a.5.5 0 0 1 0-1h.5v-2A.5.5 0 0 1 6 1Zm4 6.5h1a.5.5 0 1 1 0 1h-.5v2a.5.5 0 1 1-1 0v-2H9a.5.5 0 0 1 0-1h1ZM10 1a.5.5 0 0 1 .5.5V6a.5.5 0 1 1-1 0V1.5A.5.5 0 0 1 10 1Z",
		fill: "currentColor"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=sliders.js.map